import { ref } from 'vue'

export function useSelection(emits) {
  const selectedRows = ref(0)

  const onSelectionChanged = (gridApi) => {
    if (!gridApi.value) return

    const { selectAll, toggledNodes } = gridApi.value.getServerSideSelectionState() || {}

    let selectedCount = 0
    if (selectAll) {
      selectedCount = gridApi.value.paginationGetRowCount() - (toggledNodes?.length || 0)
    } else {
      selectedCount = toggledNodes?.length || 0
    }

    selectedRows.value = selectedCount

    emits('rows-selected', {
      selectAll,
      toggledNodes: toggledNodes || [],
      selectedCount,
    })
  }

  return { selectedRows, onSelectionChanged }
}
